import {UseFormReturn} from 'react-hook-form';

import {isElectricOrHybridFuelType} from '../../../kit/utils/isElectricOrHybridFuelType';
import {BaseVehicle} from '../../types/BaseVehicle';

export interface FormClearBatteryHealthFieldsActionParams {
  form: UseFormReturn<BaseVehicle>;
  previousFuelType: string | null;
}

/**
 * Clears battery health fields when transitioning away from electric/hybrid fuel types
 * @param _context - XState context (unused)
 * @param params - Parameters containing form instance and previous fuel type value
 */
export const formClearBatteryHealthFieldsAction = (
  _context: unknown,
  params: FormClearBatteryHealthFieldsActionParams
): void => {
  const {form, previousFuelType} = params;

  const values = form.getValues();
  const currentFuelType = values.fuelType?.[0] ?? null;

  const wasElectricOrHybrid = isElectricOrHybridFuelType(previousFuelType);
  const isCurrentElectricOrHybrid = isElectricOrHybridFuelType(currentFuelType);

  // If transitioning away from electric/hybrid, clear battery health fields
  if (wasElectricOrHybrid && !isCurrentElectricOrHybrid) {
    form.setValue('batteryCondition', null, {
      shouldDirty: false,
      shouldValidate: false,
    });
    form.setValue('batteryConditionMeasuredAt', null, {
      shouldDirty: false,
      shouldValidate: false,
    });
    form.setValue('actualBatteryRange', null, {
      shouldDirty: false,
      shouldValidate: false,
    });
    form.setValue('batteryCertificate', null, {
      shouldDirty: false,
      shouldValidate: false,
    });
    form.setValue('batteryCertificateDocument', null, {
      shouldDirty: false,
      shouldValidate: false,
    });
  }
};
